import List from './List'

const carsShockResource = {
  list: List,
}

export default carsShockResource
